export enum RoutePath {
  applicationIdErrorPage = '/applicationid-not-found',
  applicationSubmission = '/application-submission',
  applicationTracking = '/application-tracking',
  approvalInformation = '/approval-information',
  branchSelection = '/branch-selection',
  changePhoneNumber = '/change-phone-number',
  collateralConfirmation = '/konfirmasi-jaminan',
  documentInformation = '/document-information',
  faceVerificationPage = '/take-selfie',
  ktpVerificationPage = '/ktp-verifikasi',
  landingPage = '/',
  leadExpiredErrorPage = '/lead-expired',
  leadRevivePage = '/lead-revive',
  leadVerificationPage = '/verifikasi/:groupCode',
  loanEstimation = '/loan-estimation',
  loanEstimationInstallmentList = '/loan-estimation/installment-list',
  offlineTouchPoint = '/offline-touch-point',
  otpVerification = '/confirm-otp',
  personalInformation = '/personal-information',
  reviewApplication = '/review-application',
  reviewInformation = '/review-information',
  reviewVehicleAndLoan = '/review',
  takeSelfieOnly = '/take-selfie-only',
  vehicleBrand = '/choose-brand',
  vehicleDetail = '/vehicle-information',
  vehicleLocation = '/choose-city',
  vehicleModel = '/choose-model',
  vehicleVariant = '/choose-variant',
  vehicleYear = '/choose-year',
  verifyIdentityPage = '/verify-identity',
}

export enum DocumentTitle {
  applicationSubmission = 'Application Submitted | BFI Finance',
  applicationTracking = 'Application Tracking | BFI Finance',
  approvalInformation = 'Approval Information | BFI Finance',
  branchSelection = 'Branch Selection | BFI Finance',
  changePhoneNumber = 'Change phone number | BFI Finance',
  documentInformation = 'Document Information | BFI Finance',
  faceVerificationPage = 'Take Selfie | BFI Finance',
  identityVerificationPage = 'Verify Identity | BFI Finance',
  ktpVerificationPage = 'KTP Verification | BFI Finance',
  landingPage = 'Welcome | BFI Finance',
  leadExpiredErrorPage = 'Lead Expired | BFI Finance',
  loanEstimation = 'Loan Estimation | BFI Finance',
  otpVerification = 'OTP | BFI Finance',
  personalInformation = 'Personal Information | BFI Finance',
  reviewApplication = 'Review Application | BFI Finance',
  reviewInformation = 'Review Information | BFI Finance',
  reviewVehicleAndLoan = 'Review Vehicle and Loan Information | BFI Finance',
  vehicleBrand = 'Choose your brand | BFI Finance',
  vehicleDetail = 'Loan Estimation | BFI Finance',
  vehicleLocation = 'Choose city of registration | BFI Finance',
  vehicleModel = 'Choose your model | BFI Finance',
  vehicleVariant = 'Choose your variant | BFI Finance',
  vehicleYear = 'Choose year | BFI Finance',
}
